import React from "react";
import { Select } from "antd";

const { Option } = Select;

const handleChange = (value) => {
  console.log(`selected ${value}`);
};

const selectCity = () => {
  return (
    <div className="acc-select-box">
   
      <Select
        defaultValue="Select your city"
        style={{
          width: 230,
        }}
        onChange={handleChange}
      >
        <Option value="jack">Pune</Option>
        <Option value="lucy">Surat</Option>

        <Option value="Yiminghe">Gujarat</Option>
      </Select>
    </div>
  );
};

export default selectCity;
